module.exports = __webpack_public_path__ + "media/images/gallery-2-f9a1bbd3.jpg";